import axios from 'axios';
import { startRegistration } from '@simplewebauthn/browser';

export default {
  fetchCredentials: async ({ commit }) => {
    commit('SET_LOADING', true);
    try {
      const response = await axios.get('/engine/fido/credentials');
      commit('SET_CREDENTIALS', response.data);
    } catch (err) {
      /* eslint-disable-next-line */
      console.error('Failed to fetch passkey credentials:', err);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  registerPasskey: async ({ commit, dispatch }, friendlyName) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    try {
      // 1. Get registration options from server
      const optionsResp = await axios.post('/engine/fido/register/start');
      const options = optionsResp.data;

      // 2. Start WebAuthn registration (browser prompts for biometric/key)
      const credential = await startRegistration({ optionsJSON: options });

      // 3. Send attestation to server for verification + storage
      const payload = { ...credential };
      if (friendlyName) {
        payload.friendlyName = friendlyName;
      }
      await axios.post('/engine/fido/register/public-key', payload);

      // 4. Refresh credentials list
      await dispatch('fetchCredentials');

      return { success: true };
    } catch (err) {
      /* eslint-disable-next-line */
      console.error('Passkey registration failed:', err);
      return { success: false, error: err.message || 'Registration failed' };
    } finally {
      commit('ui/HIDE_OVERLAY', true, { root: true });
    }
  },

  deleteCredential: async ({ commit, dispatch }, credentialId) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    try {
      await axios.delete(`/engine/fido/credentials/${credentialId}`);
      await dispatch('fetchCredentials');
      return { success: true };
    } catch (err) {
      /* eslint-disable-next-line */
      console.error('Failed to delete passkey:', err);
      return { success: false, error: err.message || 'Delete failed' };
    } finally {
      commit('ui/HIDE_OVERLAY', true, { root: true });
    }
  }
};
